import Creator1 from '../../Attachments/Image/TopCreators/Creator1.png';
import Creator2 from '../../Attachments/Image/TopCreators/Creator2.png';
import Creator3 from '../../Attachments/Image/TopCreators/Creator3.png';
import Creator4 from '../../Attachments/Image/TopCreators/Creator4.png';


const TopCreatorsData = [
    {
        profImg: Creator1,
        profName: "Johnny Lee",
        alt: "Johnny Lee's Profile",
        maxIncome: 5.21,
        items: 47,
    },
    {
        profImg: Creator2,
        profName: "Wzard Dee",
        alt: "Wzard Dee's Profile",
        maxIncome: 4.89,
        items: 33,
    },
    {
        profImg: Creator3,
        profName: "Katheryn Zephersky",
        alt: "Katheryn Zephersky's Profile",
        maxIncome: 6.49,
        items: 60,
    },
    {
        profImg: Creator4,
        profName: "Zach Arts",
        alt: "Zach Art's Profile",
        maxIncome: 3.89,
        items: 23,
    },
];

export default TopCreatorsData